import { render } from "./JModalSlideTab.vue?vue&type=template&id=0d7ea459"
import script from "./JModalSlideTab.vue?vue&type=script&lang=js"
export * from "./JModalSlideTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__